export default {
  title: "Company profile",
  profileComplete: "Completed",
  profileNotComplete: "Partly filled in",

  modal: {
    logo: "Company logo",
    logoDescription: "Provide a png, jpg or jpeg file.",
    logoSize: "The maximum file size is 2 MB.",
    logoResolution: "The maximum file resolution is 1024x124",
    logoLoadBtn: "Load",
    logoRemoveBtn: "Remove",
    logoLoadingBtn: "Loading {name}...",

    companyNameLang1: "Company name in Russian",
    companyNameLang2: "Company name in English",

    country: "Country",

    email: "E-mail",

    addressForm: {
      title: "Legal address",
      address: "Address"
    },

    mailingAddress: "Mailing address",

    companyPhone: "Company phone",
    companyFax: "Company fax",

    rubricatorTitle: "Headings",

    inn: "Registration №",
    okved: "OKVED",

    companyTypes: "Сompany business activity",
    companySizes: "Choose if this relates to your company business",
    companyScope: "Your company's scope",
    companyProductRole: "Application spheres of your products and services",

    counterpartyShowBtn: "View contractor (payer) details",
    counterpartyHideBtn: "Hide contractor (payer) details",

    counterpartyName: "Contractor (payer) name",
    counterpartyLegalAddress: "Legal address",
    counterpartyKpp: "KPP",
    counterpartyBank: "Bank",
    counterpartyBik: "BIK",
    counterpartyCorAccount: "Correspondent account",
    counterpartyCheckAccount: "Checking account",

    submit: "Save",
    submitting: "Saving...",
    websiteError:
      " The field may contain latin and cyrillic letters, numbers, hyphens,\n" +
      "          underscores, periods, colons, slashes."
  }
};
